import React from "react";
import { css } from "aphrodite";
import { Accordion, Nav, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import styles from "./style";
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import SubSubmenu from "../SubSubmenu";

class SubMenu extends React.Component {
  constructor(props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render() {
    const { icon, title, items } = this.props;
    //console.log("items...",items)
    
    return (
      <Nav.Item>
        {/* <Accordion>
        <Accordion.Item eventKey="0">
        <Accordion.Header>
            <FontAwesomeIcon icon={icon} className="mr-2" style={{paddingRight: "5px"}} />
            {title}
        </Accordion.Header>
        <Accordion.Body>
        <nav className={css(styles.navLinkStyle)}>
              {items.map(item => (
                <a
                  className={`nav-link nav-item pl-5 ${
                    item === "Active" ? "active" : ""
                  } `}
                  href="/"
                  key={item}
                >
                  {item}
                </a>
              ))}
            </nav>
        </Accordion.Body>
        </Accordion.Item>
        </Accordion> */}

        <Accordion flush>
        <Card style={{border : "0px"}}>
        <Card.Header className={[css(styles.headerStyle)]}>
          <CustomToggle eventKey="0" icon={icon} title={title} collapsed={this.state.collapsed} />
        </Card.Header>
        <Accordion.Collapse eventKey="0" >
          <Card.Body className={[css(styles.navLinkStyle)]}>
          <nav>
              {items.map((item, index) => (
                item.subMenus.length !== 0 ?
                <SubSubmenu
                  key={item.subMenus.id + "_" + index}
                  title={item.menuName}
                  icon={item.iconClass}
                  items={item}
                />
                :
                <a
                  className={`nav-link nav-item pl-5 ${
                    css(styles.navItemsStyle)
                  } `}
                  style={{color: "#adb5bd"}}
                  href={item.path}
                  key={item.id + "_" + index}
                >
                  <i className={item.iconClass} style={{paddingRight: "5px"}} />
                  {item.menuName}
                </a>
              ))}
            </nav>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
      </Accordion>
      </Nav.Item>
    );

  }
}

function CustomToggle({ children, eventKey, icon, title, callback, collapsed }) {
    
    const decoratedOnClick = useAccordionButton(eventKey, () =>
      callback && callback(eventKey),
    );


    return (
        <button onClick={decoratedOnClick} className={[css(styles.buttonStyle)]}>
        <i className={icon} style={{paddingRight: "5px"}} />
        {title}
        <FontAwesomeIcon
          icon={collapsed ? faCaretDown : faCaretUp}
          style={{float: "right"}}
        />
        </button>
    );
  }

export default SubMenu;
